import { Container } from "./styles";
import { Column } from "components/styles";
import SpaceReservationTitle from "./SpaceReservationTitle";
import SpaceDetails from "./SpaceDetails";
import SpaceDurationData from "../../../components/SpaceDurationData";
import SpaceLocationData from "./SpaceLocationData";
import SpaceFeatureData from "../../../components/SpaceFeatureData";
import SpaceReservationActivity from "./SpaceReservationActivity";
import ReservationState from "../../../components/ReservationState";
import useSpaceReservationState from "../utils/hooks/useSpaceReservationState";
import useCancelSpaceReservation from "../../../utils/hooks/useCancelSpaceReservation";
import CancelReservationButton from "views/Recursos/ResourcesUniversitySpaces/components/CancelReservationButton";
import StudentListButton from "../StudentListButton";
import DialogCancelReservation from "views/Recursos/ResourcesUniversitySpaces/components/DialogCancelReservation";
import { RESOURCES_CONSTANTS } from "config/constants";
import useSaveRegularReservationInformation from "../utils/hooks/useSaveRegularReservationInformation";

const reservationType = RESOURCES_CONSTANTS.RESERVATION_TYPES.REGULAR;
const ReservationMainView = ({
    goToListStudentReservationView,
    updateActivityPopup,
    reservation
}) => {
    const {
        schedule, students,
        activity, space, finalized
    } = reservation;
    const { cancelReservation, dialogCancelReservation } = useCancelSpaceReservation({
        updateActivityPopup, reservation,
        reservationType
    });
    const reservationState = useSpaceReservationState({
        finalized, updateActivityPopup
    });
    const saveReservationInformationHandler = useSaveRegularReservationInformation({
        reservation, reservationState,
        reservationType, updateActivityPopup
    });
    return (
        <>
            <Container>
                <Column gap="6px">
                    <SpaceReservationTitle students={students} />
                    <SpaceDetails details={space.details} />
                    <SpaceDurationData schedule={schedule} />
                    <SpaceLocationData space={space} />
                    <SpaceReservationActivity activity={activity} />
                </Column>
                <SpaceFeatureData {...space} />
                <Column gap="12px">
                    <CancelReservationButton
                        reservation={reservation}
                        openDialogCancelReservation={dialogCancelReservation.open} />
                    <StudentListButton
                        goToListStudentReservationView={goToListStudentReservationView} />
                </Column>
                <ReservationState
                    reservation={reservation}
                    reservationState={reservationState}
                    updateActivityPopup={updateActivityPopup}
                    reservationType={reservationType}
                    saveReservationInformationHandler={saveReservationInformationHandler} />
            </Container>
            <DialogCancelReservation
                dialog={dialogCancelReservation}
                cancelReservation={cancelReservation} />
        </>
    );
}

export default ReservationMainView;